document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-button");
  const logoItems = document.querySelectorAll(".logo-item");
  const noCollectionsMessage = document.getElementById("no-collections-message");
  const loadMoreSection = document.querySelector(".load-more");
  const loadMoreBtn = document.querySelector(".brand-button");

  filterButtons.forEach(button => {
    button.addEventListener("click", function () {
      const selectedLetter = this.dataset.letter;
      let hasCollections = false;

      logoItems.forEach(item => {
        const itemLetter = item.dataset.letter;

        if (selectedLetter === "all" || itemLetter === selectedLetter) {
          item.style.display = "block";
          hasCollections = true;
        } else {
          item.style.display = "none";
        }
      });

      if (hasCollections) {
        noCollectionsMessage.classList.add("hidden");
      } else {
        noCollectionsMessage.classList.remove("hidden");
      }

      // Hide load more during filter
      if (loadMoreSection) loadMoreSection.style.display = "none";

      filterButtons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");
    });
  });

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener("click", function () {
      document.querySelectorAll(".logo-item.hidden").forEach(item => {
        item.classList.remove("hidden");
        item.style.display = "block";
      });

      if (loadMoreSection) loadMoreSection.style.display = "none";
    });
  }
});
